// extracted by mini-css-extract-plugin
export default {"container":"WWq3QF67XTZYKNtkdtxB","pageTitle":"MCgl62azpSeWlQg1kWbk","box":"PyGkEKub80r48AhnPOYp","infoRow":"d0wXqWET4wuMybR618Qy","buttonRow":"LUhhFHNTsQICiII3KEJE"};